<div class="pagination-footer">
  <div class="pagination-controls">
    <div class="rows-per-page">
      <div class="rows-per-page-label body-s">{{ 'translations.global.pagination.rowsPerPage' | transloco }}</div>
      <mat-select class="select-field" [value]="pageSize()" (valueChange)="onPageSizeChange($event)">
        @for (option of pageSizeOptions(); track $index) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </div>

    <div class="pagination-info body-s">{{ startItem() }} - {{ endItem() }} of {{ totalItems() }}</div>

    <div class="navigation-controls">
      <ptl-button
        [type]="'tertiary-neutral'"
        [icon]="ArrowLeft01Icon"
        [disabled]="currentPage() === 1"
        (click)="onPreviousPage()"
        [attr.aria-label]="'translations.global.pagination.previousPage' | transloco"
      >
      </ptl-button>

      <ptl-button
        [type]="'tertiary-neutral'"
        [icon]="ArrowRight01Icon"
        [disabled]="currentPage() === totalPages()"
        (click)="onNextPage()"
        [attr.aria-label]="'translations.global.pagination.nextPage' | transloco"
      >
      </ptl-button>
    </div>
  </div>
</div>
